function checkIsRequired(text: string, isRequire: boolean, disabled: boolean): boolean {
    return !(!isRequire || disabled || String(text).length > 0)
}
export { checkIsRequired }
